// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navItem {
  padding: 6px 8px;
  margin-bottom: 0px;
  cursor: pointer;
}

.navItem  a {
  text-decoration: none;
  color: inherit;
}

.navItem:hover {
  background-color: #f4f4f4;
}

.navItemActive {
  background-color: #e8e8e8;
}

.navItemActive:hover {
  background-color: #e0e0e0;
}

body.theme-dark .navItem:hover {
  background-color: rgba(255, 255, 255, 0.06);
}

body.theme-dark .navItemActive {
  background-color: rgba(255, 255, 255, 0.1);
  box-shadow: inset 3px 0 0 0 var(--vis-color0, #3b82f6);
}

body.theme-dark .navItemActive:hover {
  background-color: rgba(255, 255, 255, 0.14);
}

body.theme-dark .navItemActive .navItemTitle {
  color: #f2f2f2;
}

body.theme-dark .navItemActive .navItemSubTitle {
  color: #a8a8a8;
}

.navItemTitle {
  font-weight: 400;
  font-size: 10pt;
}

.navItemSubTitle {
  font-size: 8pt;
  color: var(--color-grey);
}
`, "",{"version":3,"sources":["webpack://./src/components/NavigationItem/style.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,sDAAsD;AACxD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B","sourcesContent":[".navItem {\n  padding: 6px 8px;\n  margin-bottom: 0px;\n  cursor: pointer;\n}\n\n.navItem  a {\n  text-decoration: none;\n  color: inherit;\n}\n\n.navItem:hover {\n  background-color: #f4f4f4;\n}\n\n.navItemActive {\n  background-color: #e8e8e8;\n}\n\n.navItemActive:hover {\n  background-color: #e0e0e0;\n}\n\nbody.theme-dark .navItem:hover {\n  background-color: rgba(255, 255, 255, 0.06);\n}\n\nbody.theme-dark .navItemActive {\n  background-color: rgba(255, 255, 255, 0.1);\n  box-shadow: inset 3px 0 0 0 var(--vis-color0, #3b82f6);\n}\n\nbody.theme-dark .navItemActive:hover {\n  background-color: rgba(255, 255, 255, 0.14);\n}\n\nbody.theme-dark .navItemActive .navItemTitle {\n  color: #f2f2f2;\n}\n\nbody.theme-dark .navItemActive .navItemSubTitle {\n  color: #a8a8a8;\n}\n\n.navItemTitle {\n  font-weight: 400;\n  font-size: 10pt;\n}\n\n.navItemSubTitle {\n  font-size: 8pt;\n  color: var(--color-grey);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navItem": `navItem`,
	"navItemActive": `navItemActive`,
	"themeDark": `theme-dark`,
	"navItemTitle": `navItemTitle`,
	"navItemSubTitle": `navItemSubTitle`
};
export default ___CSS_LOADER_EXPORT___;
